import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { LoginService } from '@core/services/login.service';
import { UiService } from '@core/services/ui.service';

import { ChangeTitleComponent } from '../../modals/change-title/change-title.component';

@Injectable({
  providedIn: 'root'
})
export class AgentGuard implements CanActivate {
  constructor(private loginService: LoginService, private router: Router, private uiService: UiService) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const extractedUrl = this.router.getCurrentNavigation()?.extractedUrl;
    const zonaAliadosToken = extractedUrl?.queryParams.zaToken;
    if (zonaAliadosToken) {
      this.loginService.onLogout();
      return true;
    }
    const importLifePlanId = extractedUrl?.queryParams.import;
    const tokenPayloadData = await this.loginService.isAgentAuthenticated();
    if (route.url.length > 0) {
      if (tokenPayloadData) {
        if (route.url[0].path === 'home' || route.url[0].path === 'login') {
          this.router.navigateByUrl('/agent/life-plans');
          return false;
        }
        return true;
      }
      if (route.url[0].path === 'agent') {
        if (route.url[1].path === 'life-plans' && importLifePlanId) {
          this.router.navigateByUrl(`/login?import=${importLifePlanId}`);
          return false;
        }
        this.router.navigateByUrl('/login');
        return false;
      }
      return true;
    } else {
      return true;
    }
  }
}
